import React from 'react'
import PostFeed from 'components/shared/PostList/PostFeed'

export default function CommentedPage() {
  return (
    <PostFeed />
  )
}
